import { useSelector } from 'react-redux';
import lodash from 'lodash';

export default (...roles) =>
  useSelector(state => {
    const currentRole = lodash.get(state, 'auth.currentUser.role');
    return roles.includes(currentRole);
  });
